<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { WoozyMaterial } from '../../Reusable/WoozyMaterial'
import { Mesh, Color, PlaneBufferGeometry } from 'three'

export default {
  mixins: [O3DG2],
  props: {
    size: {
      default: 50
    },
  },
  methods: {
    setup () {
      let mat = new WoozyMaterial()
      let geo = new PlaneBufferGeometry(70, 30, 32, 32)
      // geo = new PlaneBufferGeometry(100, 40)
      this.ctx.cubeCam.add(this.o3d)

      mat.envMap = this.ctx.cubeCam.out.envMap
      mat.uniforms.useDudv.value = true
      mat.uniforms.remixColor.value = new Color('#bababa')
      mat.uniforms.mRefractionRatio.value = 1
      mat.uniforms.mFresnelBias.value = 10
      mat.uniforms.opacity.value = 0.5
      mat.transparent = true

      // mat.blending = MultiplyBlending

      let mesh = new Mesh(geo, mat)
      this.o3d.add(mesh)

      this.onLoop(() => {
        mat.uniforms.time.value += 0.1
      })
    }
  },
  mounted () {
    this.setup()
    this.$watch('size', () => {
      this.o3d.children.forEach((s) => {
        this.o3d.remove(s)
      })
      this.setup()
    })
  }
}
</script>

<style>
</style>